import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import View from './View';

const Membership2 = ({formContext, themeName}) => {
  return <View formContext={formContext} themeName={themeName} textField={'membershipTextHtml_txt'} titleField={'membershipTitle'} />;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    themeName: state.reducer.theme
  };
};

export default connect(mapStateToProps)(withRouter(Membership2));

